<style lang="scss" scoped>
.font-weight {
    font-weight: 800;
}
</style>
<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="180"
                placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="supplierEditForm"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="180"
            />
        </compWrapper>
        <div v-if="type!='query'" class="text-right">
            <vButton class="margin-right-20" theme="primary" @click="submit">保存</vButton>
			<vButton class="margin-right-20" @click="cancel">取消</vButton>
        </div>
        <!-- 操作历史 -->
        <!-- <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper> -->

        <vLoading size="large" transfer :loading="loading"></vLoading>

    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpGetAgreementOne,HttpSaveAgreement } from "@/service/managechannel/managechannel"


export default {
    props:['activeid','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            formData:{
                daPointScale:null,
                coopPointScale:null,
                termsdiscountPointScale:null,
                freightPointScale:null,
                avsPointScale: null,
                cycle:null,
            },
            logList:[],
            downcateoryList:[],
            loading:false,
            titleName:'',
            daRequired: false,
            coopRequired: false,
            termsdiscountRequired: false,
            freightRequired: false,
            avsRequired: false,
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
	},
    created(){
        this.update();
        
    },
    computed:{
        ...mapGetters('diction',['getNewAccountList']),
        getAccount () {
            return this.getNewAccountList.filter(item => {
                return item.attach.status != 'inactive'
            });
        },
        getBase(){
            return [
                {
					label: "渠道账号",
					key: "accountId",
                    tag: "vSelect",
                    options:this.getAccount.map(item=>{
                        return {
                            label:item.label,
                            value:item.attach.id
                        }
                    }),
                    props:{
                        filterable:true,
                        clearable:true,
                    },
                    query:this.type!='add',
				},
                {
					label: "周期协议",
                    tag: 'vDatepicker',
                    key: 'BT_cycle',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false
                    },
                },
                {
					label: "DA Agreement ID",
					key: "daAgreementId",
                    required: this.daRequired,
                },
                {
					label: "DA扣点比例(%)",
                    key:'daPointScale',
                    tag: "InputNumber",
                    props:{
                        style:'width:100%',
                        min:0,
                        max:100
                    },
                    required: false,
                    on: {
                        "on-change": (val) => {
                            if (val > 0) {
                                this.$set(this, "daRequired", true);
                            }
                            else {
                                this.$set(this, "daRequired", false);
                            }
                        }
                    }
                },
                {
                    label: 'Warehouse Code',
                    key: 'warehouseCode',
                    tag: "vInput",
                    required:false,
                },
                {
                    label: 'Category',
                    key: 'category',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "Vendor Code",
                    key:'vendorCode',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "COOP Agreement ID",
                    key:'coopAgreementId',
                    tag: "vInput",
                    required: this.coopRequired,
                },
                {
					label: "COOP 扣点比例(%)",
                    key:'coopPointScale',
                    tag: "InputNumber",
                    props:{
                        style:'width:100%',
                        min:0,
                        max:100
                    },
                    required:false,
                    on: {
                        "on-change": (val) => {
                            if (val > 0) {
                                this.$set(this, "coopRequired", true);
                            }
                            else {
                                this.$set(this, "coopRequired", false);
                            }
                        }
                    }
                },
                {
					label: "Termsdiscount Agreement ID",
                    key:'termsdiscountAgreementId',
                    tag: "Input",
                    required: this.termsdiscountRequired,
                },
                {
					label: "Termsdiscount扣点比例(%)",
                    key:'termsdiscountPointScale',
                    tag: "InputNumber",
                    props:{
                        style:'width:100%',
                        min:0,
                        max:100
                    },
                    required:false,
                    on: {
                        "on-change": (val) => {
                            if (val > 0) {
                                this.$set(this, "termsdiscountRequired", true);
                            }
                            else {
                                this.$set(this, "termsdiscountRequired", false);
                            }
                        }
                    }
                },
                {
					label: "Freight Agreement ID",
                    key:'freightAgreementId',
                    tag: "Input",
                    required: this.freightRequired,
                },
                {
					label: "Freight扣点比例(%)",
                    key:'freightPointScale',
                    tag: "InputNumber",
                    props:{
                        style:'width:100%',
                        min:0,
                        max:100
                    },
                    required:false,
                    on: {
                        "on-change": (val) => {
                            if (val > 0) {
                                this.$set(this, "freightRequired", true);
                            }
                            else {
                                this.$set(this, "freightRequired", false);
                            }
                        }
                    }
                },
                {
					label: "AVS Agreement ID",
                    key:'avsAgreementId',
                    tag: "Input",
                    required: this.avsRequired,
                },
                {
					label: "AVS扣点比例(%)",
                    key:'avsPointScale',
                    tag: "InputNumber",
                    props:{
                        style:'width:100%',
                        min:0,
                        max:100
                    },
                    required:false,
                    on: {
                        "on-change": (val) => {
                            if (val > 0) {
                                this.$set(this, "avsRequired", true);
                            }
                            else {
                                this.$set(this, "avsRequired", false);
                            }
                        }
                    }
                },
                {
					label: "回款周期",
                    key:'cycle',
                    tag: "InputNumber",
                    props:{
                        style:'width:100%',
                        min:0,
                        max:100
                    },
                    required:false,
                },
            ]
        },
    },
    methods:{
        /**
         * 所有带PointScale的字段全部检查>0且设置对应的agreementId必填
         */
        setRequired (formData) {
            Object.keys(formData).map(key => {
                if (key.indexOf("PointScale") != -1) {
                    let keyName = key.replace("PointScale", "Required");
                    if (formData[key] > 0) {
                        this.$set(this, keyName, true);
                    }
                    else {
                        this.$set(this, keyName, false);
                    }
                }
            });
        },
        validRequired (formData) {
            let flag = true;
            Object.keys(formData).map(key => {
                if (key.indexOf("PointScale") != -1) {
                    let requiredKeyName = key.replace("PointScale", "Required");
                    let agreementIdKeyName = key.replace("PointScale", "AgreementId");
                    let showKeyName = key.replace("PointScale", "");
                    if (this[requiredKeyName] && !formData[agreementIdKeyName]) {
                        this.$VMessage.error(`${showKeyName} Agreement ID必填，请检查`);
                        flag = false;
                    }
                }
            });
            return flag;
        },
        async update(){
            if(this.type == 'add') return;
            this.loading = true;
            await HttpGetAgreementOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                this.formData.BT_cycle = res.data.startTime+' ~ '+res.data.endTime
                this.setRequired(res.data);
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 10,
                    closable: true,
                });
            })
            this.loading = false;
        },
        async submit(){
            let cyclearr = this.formData.BT_cycle.split('~');
            this.formData.startTime = cyclearr[0];
            this.formData.endTime = cyclearr[1];
            if (!this.validRequired(this.formData)) return;
            this.loading = true;
            await HttpSaveAgreement({
                orgId:global.SYSID,
                ...this.formData
            }).then(res=>{
                this.$Message.success(res.message);
                this.cancel();

            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 10,
                    closable: true,
                });
            })
            this.loading = false;
        },
        cancel(){
            this.$router.push({
                name: 'agreementList',
            })
        },
    }
}
</script>

